import ImageIcon from "../../../assets/img.png";
import MapIcon from "../../../assets/map.png";
import FriendIcon from "../../../assets/friend.png";

export const ShareActions = ({ 
    handleFileChange, errorMsg, isSubmitting, cooldown, desc, files, onShareClick 
}) => {
    const isDisable = (!desc && (!files || files.length === 0)) || isSubmitting || cooldown > 0;

    return (
        <div className="bottom">
            {errorMsg && (
                <div style={{ color: "red", fontSize: "14px", marginBottom: "10px", width: "100%" }}>
                    {errorMsg}
                </div>
            )}

            <div className="options">
                <input 
                    type="file" 
                    id="fileModal" 
                    multiple style={{ display: "none" }} 
                    onChange={handleFileChange} 
                    accept="image/*,video/*"
                />
                
                <label htmlFor="fileModal" className="option">
                    <img src={ImageIcon} alt="" />

                    <span className="optionText">
                        Photo/Video
                    </span>
                </label>

                <div className="option">
                    <img src={MapIcon} alt="" />

                    <span className="optionText">
                        Check-in
                    </span>
                </div>

                <div className="option">
                    <img src={FriendIcon} alt="" />

                    <span className="optionText">
                        Tag Friend
                    </span>
                </div>
            </div>

            <button className="shareBtn" onClick={onShareClick} disabled={isDisable}>
                {isSubmitting ? "Processing..." : cooldown > 0 ? `Wait ${cooldown}s` : "Share"}
            </button>
        </div>
    );
};